(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scntd-card-bundle-inline"] && !Shopify.designMode) return;
  try {
    function initScntdInlineBundles(root) {
    root.querySelectorAll('[data-scntd-inline-bundle]').forEach((builder) => {
      if (builder.dataset.bundleReady === 'true') return;
      builder.dataset.bundleReady = 'true';

      const packInputs = Array.from(builder.querySelectorAll('[data-pack-option]'));
      const panel = builder.querySelector('[data-bundle-panel]');
      const cards = Array.from(builder.querySelectorAll('[data-bundle-card]'));
      const addButton = builder.querySelector('[data-bundle-add]');
      const buttonLabel = builder.querySelector('[data-bundle-button-label]');
      const spinner = builder.querySelector('[data-bundle-spinner]');
      const status = builder.querySelector('[data-bundle-selection-status]');
      const message = builder.querySelector('[data-bundle-message]');
      const originalTotal = builder.querySelector('[data-bundle-original-total]');
      const bundleTotal = builder.querySelector('[data-bundle-total]');
      const saving = builder.querySelector('[data-bundle-saving]');
      const locale = builder.dataset.locale || 'en';
      const currency = builder.dataset.currency || 'PKR';
      const defaultProductFormElement = document.getElementById(builder.dataset.productFormId);
      const defaultProductForm = defaultProductFormElement?.closest('product-form');
      const currentCard = cards.find((card) => card.dataset.currentProduct === 'true');
      const isBundleProductPage = builder.dataset.bundleProductPage === 'true';
      const productInfo = builder.closest('.product__info-container');
      const defaultVariantPicker = productInfo?.querySelector('variant-selects');
      const defaultQuantity = productInfo?.querySelector('[id^="Quantity-Form-"]');
      const pagePrice = productInfo?.querySelector('[id^="price-"]');
      const pageRegularPrice = pagePrice?.querySelector('.price__regular .price-item--regular');
      const pageComparePrice = pagePrice?.querySelector('.price__sale s.price-item--regular');
      const pageSalePrice = pagePrice?.querySelector('.price__sale .price-item--sale');
      const initialPagePrice = {
        regular: pageRegularPrice?.textContent || '',
        compare: pageComparePrice?.textContent || '',
        sale: pageSalePrice?.textContent || '',
      };

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const attentionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            builder.classList.add('is-attention-ready');
            observer.unobserve(builder);
          });
        }, { threshold: 0.45, rootMargin: '0px 0px -8%' });
        attentionObserver.observe(builder);
      }

      const formatMoney = (cents) => new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'code',
        maximumFractionDigits: 0,
      }).format(cents / 100);

      const getPackInput = () => packInputs.find((input) => input.checked);
      const getSelectedCards = () => cards.filter((card) => card.querySelector('[data-bundle-toggle]').checked);
      const getCardQuantity = (card) => Number(card.dataset.bundleQuantity || 1);
      const getSelectedCount = () => getSelectedCards().reduce((total, card) => total + getCardQuantity(card), 0);
      const syncVariantRows = (card, quantity) => {
        const container = card.querySelector('[data-bundle-variants]');
        let rows = Array.from(container.querySelectorAll('[data-bundle-variant-row]'));

        while (rows.length < quantity) {
          container.append(rows[0].cloneNode(true));
          rows = Array.from(container.querySelectorAll('[data-bundle-variant-row]'));
        }
        while (rows.length > quantity) rows.pop().remove();

        Array.from(container.querySelectorAll('[data-bundle-variant-row]')).forEach((row, index) => {
          const copyNumber = index + 1;
          const select = row.querySelector('[data-bundle-variant]');
          const label = row.querySelector('[data-bundle-variant-label]');
          const id = `${card.dataset.variantBaseId}-${copyNumber}`;
          select.id = id;
          label.htmlFor = id;
          label.querySelector('[data-bundle-copy-number]').textContent = String(copyNumber);
        });
      };
      const primeBundleWithCurrentProduct = () => {
        cards.forEach((card) => {
          card.querySelector('[data-bundle-toggle]').checked = false;
          card.dataset.bundleQuantity = '1';
          syncVariantRows(card, 1);
        });
        if (!currentCard || currentCard.classList.contains('is-unavailable')) return;

        currentCard.querySelector('[data-bundle-toggle]').checked = true;
        const pageVariantId = defaultProductFormElement?.querySelector('[name="id"]')?.value;
        const currentVariant = currentCard.querySelector('[data-bundle-variant]');
        if (pageVariantId && currentVariant.querySelector(`option[value="${pageVariantId}"]`)) {
          currentVariant.value = pageVariantId;
        }
      };
      const setPurchaseMode = (bundleSelected) => {
        if (!defaultProductForm) return;
        const hideDefaultPurchase = isBundleProductPage || bundleSelected;
        defaultProductForm.classList.toggle('scntd-bundle-default-buy--hidden', hideDefaultPurchase);
        defaultProductForm.toggleAttribute('hidden', hideDefaultPurchase);
        defaultProductForm.setAttribute('aria-hidden', String(hideDefaultPurchase));
      };
      const updatePagePrice = (packInput) => {
        if (!isBundleProductPage || !packInput) return;

        const regularPrice = packInput.dataset.packOriginalTotalFormatted || '';
        const bundlePrice = packInput.dataset.packBundleTotalFormatted || '';
        if (pageRegularPrice) pageRegularPrice.textContent = bundlePrice;
        if (pageComparePrice) pageComparePrice.textContent = regularPrice;
        if (pageSalePrice) pageSalePrice.textContent = bundlePrice;
      };
      const restorePagePrice = () => {
        if (!isBundleProductPage) return;

        if (pageRegularPrice) pageRegularPrice.textContent = initialPagePrice.regular;
        if (pageComparePrice) pageComparePrice.textContent = initialPagePrice.compare;
        if (pageSalePrice) pageSalePrice.textContent = initialPagePrice.sale;
      };
      const clearPackSelection = () => {
        packInputs.forEach((input) => {
          input.checked = false;
          input.setAttribute('aria-expanded', 'false');
        });
        cards.forEach((card) => {
          const toggle = card.querySelector('[data-bundle-toggle]');
          const quantityControl = card.querySelector('[data-bundle-quantity-control]');
          const quantityOutput = card.querySelector('[data-bundle-quantity]');
          const decreaseButton = card.querySelector('[data-bundle-decrease]');
          const increaseButton = card.querySelector('[data-bundle-increase]');

          toggle.checked = false;
          toggle.disabled = card.classList.contains('is-unavailable');
          card.dataset.bundleQuantity = '1';
          syncVariantRows(card, 1);
          card.classList.remove('is-selected', 'is-disabled');
          card.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
            variant.disabled = true;
          });
          quantityControl.hidden = true;
          quantityOutput.textContent = '1';
          decreaseButton.disabled = true;
          increaseButton.disabled = true;
        });

        panel.classList.remove('is-visible');
        panel.hidden = true;
        addButton.disabled = true;
        status.textContent = '';
        message.hidden = true;
        setPurchaseMode(false);
        restorePagePrice();
      };

      if (isBundleProductPage) {
        [defaultVariantPicker, defaultQuantity].forEach((element) => {
          if (!element) return;
          element.hidden = true;
          element.setAttribute('aria-hidden', 'true');
        });
      }

      const update = () => {
        const packInput = getPackInput();
        if (!packInput) return;

        const packSize = Number(packInput.value);
        let selectedCards = getSelectedCards();
        let selectedCount = getSelectedCount();

        if (selectedCount > packSize) {
          let remaining = packSize;
          selectedCards.forEach((card) => {
            const toggle = card.querySelector('[data-bundle-toggle]');
            if (remaining === 0) {
              toggle.checked = false;
              card.dataset.bundleQuantity = '1';
              return;
            }

            const quantity = Math.min(getCardQuantity(card), remaining);
            card.dataset.bundleQuantity = String(quantity);
            remaining -= quantity;
          });
          selectedCards = getSelectedCards();
          selectedCount = getSelectedCount();
        }

        cards.forEach((card) => {
          const toggle = card.querySelector('[data-bundle-toggle]');
          const quantityControl = card.querySelector('[data-bundle-quantity-control]');
          const quantityOutput = card.querySelector('[data-bundle-quantity]');
          const decreaseButton = card.querySelector('[data-bundle-decrease]');
          const increaseButton = card.querySelector('[data-bundle-increase]');
          const selected = toggle.checked;
          const quantity = selected ? getCardQuantity(card) : 1;
          const atLimit = selectedCount >= packSize;
          syncVariantRows(card, quantity);
          card.classList.toggle('is-selected', selected);
          card.classList.toggle('is-disabled', !selected && atLimit);
          if (!card.classList.contains('is-unavailable')) toggle.disabled = !selected && atLimit;
          card.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
            variant.disabled = !selected;
          });
          quantityControl.hidden = !selected;
          quantityOutput.textContent = String(quantity);
          decreaseButton.disabled = quantity <= 1;
          increaseButton.disabled = atLimit;
        });

        const selectionComplete = selectedCount === packSize;
        const calculatedOriginal = Number(packInput.dataset.packOriginalTotal || 0);
        const calculatedBundle = Number(packInput.dataset.packBundleTotal || 0);
        const calculatedSaving = Number(packInput.dataset.packBundleSaving || 0);
        originalTotal.textContent = formatMoney(calculatedOriginal);
        bundleTotal.textContent = formatMoney(calculatedBundle);
        saving.textContent = formatMoney(calculatedSaving);
        updatePagePrice(packInput);
        status.textContent = `${selectedCount} ${builder.dataset.selectedLabel} ${packSize}`;
        addButton.disabled = !selectionComplete;
        buttonLabel.textContent = selectionComplete
          ? `${builder.dataset.addLabel} · ${formatMoney(calculatedBundle)}`
          : `${builder.dataset.chooseLabel} ${packSize - selectedCount} ${builder.dataset.cardsLabel}`;
      };

      packInputs.forEach((input) => {
        const label = input.closest('.scntd-inline-bundle__pack-option')?.querySelector('label');

        label?.addEventListener('click', (event) => {
          if (!input.checked) return;
          event.preventDefault();
          clearPackSelection();
          input.focus();
        });
        input.addEventListener('keydown', (event) => {
          if (!input.checked || (event.key !== 'Enter' && event.key !== ' ')) return;
          event.preventDefault();
          clearPackSelection();
        });
        input.addEventListener('change', () => {
          packInputs.forEach((option) => option.setAttribute('aria-expanded', String(option.checked)));
          panel.hidden = false;
          requestAnimationFrame(() => panel.classList.add('is-visible'));
          message.hidden = true;
          primeBundleWithCurrentProduct();
          setPurchaseMode(true);
          update();
        });
      });

      cards.forEach((card) => {
        const toggle = card.querySelector('[data-bundle-toggle]');
        card.addEventListener('change', (event) => {
          if (event.target.matches('[data-bundle-toggle]')) {
            card.dataset.bundleQuantity = '1';
          }
          if (event.target.matches('[data-bundle-toggle], [data-bundle-variant]')) update();
        });
        card.querySelector('[data-bundle-decrease]').addEventListener('click', () => {
          card.dataset.bundleQuantity = String(Math.max(1, getCardQuantity(card) - 1));
          update();
        });
        card.querySelector('[data-bundle-increase]').addEventListener('click', () => {
          const packInput = getPackInput();
          if (!packInput || getSelectedCount() >= Number(packInput.value)) return;
          card.dataset.bundleQuantity = String(getCardQuantity(card) + 1);
          update();
        });
      });

      addButton.addEventListener('click', async () => {
        const packInput = getPackInput();
        if (!packInput) return;

        const selectedCards = getSelectedCards();
        const packSize = Number(packInput.value);
        if (getSelectedCount() !== packSize) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        buttonLabel.textContent = builder.dataset.loadingLabel;
        spinner.classList.remove('hidden');
        message.hidden = true;

        const bundleVariantId = packInput.dataset.bundleVariantId;
        if (!bundleVariantId) {
          message.textContent = builder.dataset.errorLabel;
          message.hidden = false;
          addButton.disabled = false;
          return;
        }

        const selections = selectedCards.flatMap((card) =>
          Array.from(card.querySelectorAll('[data-bundle-variant]'))
            .slice(0, getCardQuantity(card))
            .map((variant) => {
              const selectedOption = variant.selectedOptions[0];
              return `${card.dataset.productTitle} — ${selectedOption.textContent.trim()}`;
            })
        ).map((selection, index) => `${index + 1}. ${selection}`);

        const items = [{
          id: bundleVariantId,
          quantity: 1,
          properties: {
            'Bundle size': `Pack of ${packSize}`,
            [builder.dataset.selectionPropertyLabel || 'Selections']: selections.join(' | '),
          },
        }];

        try {
          const response = await fetch(`${builder.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(builder.dataset.cartUrl);
        } catch (error) {
          message.textContent = builder.dataset.errorLabel;
          message.hidden = false;
          addButton.removeAttribute('aria-busy');
          spinner.classList.add('hidden');
          update();
        }
      });

      setPurchaseMode(isBundleProductPage || Boolean(getPackInput()));
    });
  }

  initScntdInlineBundles(document);
  document.addEventListener('shopify:section:load', (event) => initScntdInlineBundles(event.target));
  } catch(e) { console.error(e); }
})();

})();
